import { PastureService } from "./pastureService";

const pastureService = new PastureService();
export default pastureService;
